import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

/*

LIQUIDITY SOURCES PERIOD EQUATIONS



*/

const defaultColumnSize = 120;

// This values should match default values for each field.
// Type is mandatory to be an exact match of one of the categories or will not display the spreadsheet
const EMPTY_ROW_DEFAULT = {
  period: -1,
  equation: ''
};

const config = {
  EMPTY_ROW_DEFAULT,
  backColor: spreadsheetConfig.backColor, // '#F0F8FF'
  hostStyle: spreadsheetConfig.hostStyle,
  // Columns Setup
  columnsConfig: [
    { name: 'Period', displayName: 'Period', size: 0.5 * defaultColumnSize },
    { name: 'equation', displayName: 'Equation', size: 5.5 * defaultColumnSize }
  ],
  DEFAULT_VALUES: {
    rowHeight: 20,
    colWidth: 150,
    fieldValue: 0
    // spreadContentByDefault: [ EMPTY_ROW_DEFAULT ]
  },
  hLeftAlignStyle: spreadsheetConfig.align.left,
  hCenterAlignStyle: spreadsheetConfig.align.center,
  hRightAlignStyle: spreadsheetConfig.align.right
};

export const SpreadConfig = config;
